<template>
  <div>
    <div class="card-body">
      <fieldset>
        <legend class="d-flex justify-content-between mb-0">
          <span>
            Penalties
          </span>
          <div class="card-header-buttons">
            <router-link
              class="btn btn-primary"
              :to="`/penalties/create?vehicle_id=${vehicle.identifier}`"
            >
              New Penalty
            </router-link>
          </div>
        </legend>
      </fieldset>
    </div>

    <table class="table carpenter">
      <thead>
        <tr>
          <th>Claim Reference</th>
          <th>Issuing Authority</th>
          <th>External Reference</th>
          <th>Type</th>
          <th>Vehicle</th>
          <th>Penalty Paid Date</th>
          <th>Settled Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="index" v-for="(penalty, index) in penalties">
          <td>{{ penalty.hire?.incident?.source?.claim_reference }}</td>
          <td>{{ penalty.issuing_authority?.name || 'Not Available' }}</td>
          <td>{{ penalty.external_reference || 'Not Available' }}</td>
          <td>{{ penalty.penalty_type?.label || 'Not Available' }}</td>
          <td>{{ penalty.vehicle?.registration || 'Not Available' }}</td>
          <td>{{ penalty.penalty_paid_at | date }}</td>
          <td>{{ penalty.settled_date | date }}</td>
          <td>
            <router-link
              class="btn btn-primary"
              :to="`/penalties/${penalty.identifier}/edit`"
            >
              Edit
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="card-footer text-right" v-if="showPagination">
      <pagination
        :data="paginator_data"
        v-on:updateResults="getData"
      ></pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      penalties: [],
      paginator_data: null,
      filters: {}
    };
  },

  computed: {
    showPagination() {
      return (
        this.paginator_data?.next_page_url || this.paginator_data?.prev_page_url
      );
    }
  },

  mounted() {
    this.loadPenalties();
  },

  methods: {
    loadPenalties() {
      this.getData(`/penalties?per_page=${this.perPage}`);
    },

    getData(url) {
      window.Ajax.get(
        `${url}&parts=hire,issuingAuthority,penaltyType,vehicle&filter[vehicle_id]=${this.vehicle.id}`
      )
        .then(response => {
          this.penalties = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(() => {
          window.toastify.error(
            'Error',
            'Sorry, an error occurred while loading the penalties'
          );
        });
    }
  }
};
</script>
